// src/pages/Discounts.js
import React, { useEffect, useState } from "react";
import { Table, Button, message } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import DiscountForm from "./DiscountForm";
import API from "../../api";
import CustomTable from "../../components/Table/CustomTable";
import ConfirmationModal from "../../components/ConfirmationModal";

export default function Discounts() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [discountToDelete, setDiscountToDelete] = useState(null);
  const [paginationInfo, setPaginationInfo] = useState({ currentPage: 1, pageSize: 5 });

  // Fetch discounts from API
  const getDiscounts = async () => {
    try {
      const response = await API.get("/discounts");
      setDiscounts(response?.data);
    } catch (err) {
      console.error("Error fetching discounts:", err);
    }
  };

  useEffect(() => {
    getDiscounts();
  }, []);

  const handleEditClick = (discount) => {
    setIsEdit(true);
    setSelectedDiscount(discount);
    setOpenDrawer(true);
  };

  const handleAddOrEditDiscount = async (discountData) => {
    try {
      if (isEdit) {
        await API.put(`/discounts/${selectedDiscount?._id}`, discountData);
        message.success("Discount updated successfully!");
      } else {
        await API.post("/discounts", discountData);
        //message.success("Discount added successfully!");
      }
      getDiscounts();
      setOpenDrawer(false);
    } catch (error) {
      console.error("Error saving discount:", error);
      message.error(error.response?.data?.message);
    }
  };

  const handleDeleteDiscount = async () => {
    try {
      await API.delete(`/discounts/${discountToDelete._id}`);
      setDiscounts(discounts.filter((discount) => discount?._id !== discountToDelete?._id));
      setIsDeleteModalVisible(false);
      message.success("Discount deleted successfully!");
    } catch (err) {
      console.error("Error deleting discount:", err);
      message.error(err.response.data.message);
    }
  };

  const columns = [
    { title: "Index", key: "index",  render: (_, __, index) =>
      (paginationInfo.currentPage - 1) * paginationInfo.pageSize + index + 1, },
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Type", dataIndex: "type", key: "type" },
    { title: "Value", dataIndex: "value", key: "value" },
    { title: "Valid From", dataIndex: "validFrom", key: "validFrom" },
    { title: "Valid Until", dataIndex: "validUntil", key: "validUntil" },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <>
          <Button icon={<EditOutlined />} onClick={() => handleEditClick(record)} />
          <Button
            icon={<DeleteOutlined />}
            danger
            style={{ marginLeft: 8 }}
            onClick={() => {
              setDiscountToDelete(record);
              setIsDeleteModalVisible(true);
            }}
          />
        </>
      ),
    },
  ];

  return (
    <div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => {
          setSelectedDiscount(null)
          setOpenDrawer(true);
          setIsEdit(false);
        }}
      >
        Add New Discount
      </Button>

      {openDrawer && (
        <DiscountForm
          open={openDrawer}
          setOpen={setOpenDrawer}
          isEdit={isEdit}
          initialValue={selectedDiscount}
          onSubmit={handleAddOrEditDiscount}
        />
      )}

      <CustomTable columns={columns} dataSource={discounts}  onPaginationChange={(pagination) =>
          setPaginationInfo({ currentPage: pagination.current, pageSize: pagination.pageSize })
      } />

      <ConfirmationModal
        visible={isDeleteModalVisible}
        onConfirm={handleDeleteDiscount}
        onCancel={() => setIsDeleteModalVisible(false)}
        title="Confirm Deletion"
        content="Are you sure you want to delete this discount? This action cannot be undone."
      />
    </div>
  );
}
